export * from './tab.component'
